// extracted by mini-css-extract-plugin
export default {"cardList":"AnalyticCoreCards_cardList__tOwqW","card":"AnalyticCoreCards_card__DZ6JJ"};